import { Box, Grid, Typography } from '@material-ui/core'
import { AddIcon, Button } from 'components/facets'
import { useTranslation } from 'react-i18next'
import { Competitor } from 'shared'
import { CompetitorBox } from '../CompetitorBox'
export interface CompetitorPresenterProps {
  competitors: Array<Competitor>
  onDelete: (id: string) => void
  onCreate: () => void
  onChange: (newValue: Competitor) => void
  onClone: (newValue: Competitor) => void
  disabled: boolean
}

interface AddCompetitorBoxProps {
  onCreate: () => void
  disabled?: boolean
}

export const AddCompetitorBox = ({
  onCreate,
  disabled = false,
}: AddCompetitorBoxProps): JSX.Element => {
  const { t } = useTranslation()
  return (
    <Button
      variant="contained"
      disabled={disabled}
      onClick={onCreate}
      startIcon={<AddIcon />}
      data-testid="add-new-competitor-btn"
      style={{ margin: 8 }}
    >
      {t('competitor.addNew')}
    </Button>
  )
}

export const CompetitorPresenter = ({
  competitors,
  onDelete,
  onCreate,
  onChange,
  disabled,
  onClone,
}: CompetitorPresenterProps): JSX.Element => {
  const { t } = useTranslation()
  return (
    <>
      <h2 className="mb-4">{t('competitor.yourCompetitors')}</h2>
      <p>{t('competitor.descriptionText')}</p>
      {disabled && (
        <Typography variant="body2" data-testid="tooltip-free-user-competitor">
          <b>{t('subscriptionUpgradeNeededNew')}</b>
        </Typography>
      )}
      <Box>
        <Grid container>
          {competitors.map((competitor) => (
            <Grid
              xs={12}
              sm={6}
              xl={4}
              key={competitor._id}
              item
              data-testid={`competitor-box-${competitor.name}`}
            >
              <CompetitorBox
                competitor={competitor}
                onDelete={disabled ? undefined : onDelete}
                onChange={disabled ? undefined : onChange}
                disabled={disabled}
                onClone={disabled ? undefined : onClone}
              />
            </Grid>
          ))}
          <Grid xs={12} sm={6} key={'new'} item>
            <AddCompetitorBox onCreate={onCreate} disabled={disabled} />
          </Grid>
        </Grid>
      </Box>
    </>
  )
}
